/**
 * The Adversários screen's route registration, discovered by `../routes.ts`'s glob, alongside
 * `../accounts/routes.ts` and `../monitoring/routes.ts`. No Figma frame names this screen (owner
 * request in a QA crunch, no design pass) -- see `./Adversaries.tsx`'s own module doc.
 */

import { createElement, type ReactNode } from 'react';
import { Swords } from 'lucide-react';
import { useParams } from '@tanstack/react-router';

import type { RouteBundle } from '../../routes/contract';
import { Adversaries } from './Adversaries';
import { dm } from './messages';
import { ADVERSARIES_PATH } from './paths';

const CONTROL_PLANE_READ = 'control_plane.read';

function AdversariesRoute(): ReactNode {
  const { campaignId } = useParams({ strict: false }) as { campaignId?: string };
  return createElement(Adversaries, { campaignId: campaignId ?? '' });
}

export const bundle: RouteBundle = {
  routes: [
    {
      path: ADVERSARIES_PATH,
      element: createElement(AdversariesRoute),
      requires: CONTROL_PLANE_READ,
      kind: 'data',
    },
  ],
  nav: [],
  campaignNav: [
    {
      path: ADVERSARIES_PATH,
      label: () => dm('title'),
      requires: CONTROL_PLANE_READ,
      icon: Swords,
      order: 45,
      kind: 'data',
    },
  ],
};
